import React, { useRef, useState } from "react";

// material-ui
import { useTheme } from "@mui/material/styles";
import {
  Box,
  ClickAwayListener,
  Grid,
  List,
  ListItemButton,
  ListItemText,
  Paper,
  Popper,
  Typography,
  useMediaQuery,
} from "@mui/material";

// project import
import IconButton from "components/@extended/IconButton";
import Transitions from "components/@extended/Transitions";
import useConfig from "hooks/useConfig";

// assets
import { TranslationOutlined } from "@ant-design/icons";
import { I18n, ThemeDirection, ThemeMode } from "types/config";

// ==============================|| HEADER CONTENT - LOCALIZATION ||============================== //

const Localization = () => {
  const { themeDirection } = useConfig();
  const theme = useTheme();
  let initialTheme = "default";
  const matchesXs = useMediaQuery(theme.breakpoints.down("md"));
  if (themeDirection === ThemeDirection.RTL) initialTheme = "rtl";
  const { i18n, onChangeLocalization, onChangeDirection } = useConfig();

  const anchorRef = useRef<any>(null);
  const [open, setOpen] = useState(false);
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: MouseEvent | TouchEvent) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const handleListItemClick = (lang: I18n) => {
    // console.log("Switching to language:", lang);
    // First change the direction
    if (lang === "ar") {
      onChangeDirection(ThemeDirection.RTL);
    } else {
      onChangeDirection(ThemeDirection.LTR);
    }
    // Then change the language
    onChangeLocalization(lang);
  };

  const iconBackColorOpen =
    theme.palette.mode === ThemeMode.DARK ? "background.default" : "grey.100";
  return (
    <Box sx={{ flexShrink: 0, ml: 0.75 }}>
      <IconButton
        color="secondary"
        variant="filled"
        sx={{
          color: "text.primary",
          bgcolor: "#fff",

          // bgcolor: open ? iconBackColorOpen : "transparent",
          border: "1px solid #E9E9E9",
        }}
        aria-label="open localization"
        ref={anchorRef}
        aria-controls={open ? "localization-grow" : undefined}
        aria-haspopup="true"
        onClick={handleToggle}
      >
        {i18n}
        {/* <TranslationOutlined /> */}
      </IconButton>
      <Popper
        placement={matchesXs ? "bottom-start" : "bottom"}
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        popperOptions={{
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [matchesXs ? 0 : 0, 9],
              },
            },
          ],
        }}
      >
        {({ TransitionProps }) => (
          <Transitions
            type="grow"
            position={matchesXs ? "top-right" : "top"}
            in={open}
            {...TransitionProps}
          >
            <Paper sx={{ boxShadow: theme.shadows[1] }}>
              <ClickAwayListener onClickAway={handleClose}>
                <List
                  component="nav"
                  sx={{
                    p: 0,
                    width: "100%",
                    minWidth: 200,
                    maxWidth: 290,
                    bgcolor: "#fff",
                    // bgcolor: theme.palette.background.paper,
                    borderRadius: 0.5,
                    [theme.breakpoints.down("md")]: {
                      maxWidth: 250,
                    },
                  }}
                >
                  <ListItemButton
                    selected={i18n === "en"}
                    onClick={() => handleListItemClick("en")}
                  >
                    <ListItemText
                      primary={
                        <Grid container>
                          <Typography color="textPrimary">English</Typography>
                          <Typography
                            variant="caption"
                            color="textSecondary"
                            sx={{ ml: "8px" }}
                          >
                            (UK)
                          </Typography>
                        </Grid>
                      }
                    />
                  </ListItemButton>
                  <ListItemButton
                    selected={i18n === "ar"}
                    onClick={() => handleListItemClick("ar")}
                  >
                    <ListItemText
                      primary={
                        <Grid container>
                          <Typography color="textPrimary">العربية</Typography>
                          <Typography
                            variant="caption"
                            color="textSecondary"
                            sx={{ ml: "8px" }}
                          >
                            (ar)
                          </Typography>
                        </Grid>
                      }
                    />
                  </ListItemButton>
                </List>
              </ClickAwayListener>
            </Paper>
          </Transitions>
        )}
      </Popper>
    </Box>
  );
};

export default Localization;
